module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/75e825d30f294735fcc1468bd74cdb71.png";